import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { useStore } from "../../../store/hooks/use-store";

export const BreadcrumbsJsonLd: ReactTFC<{
  breadcrumbs: Array<{ label: string; path: string | undefined }>;
}> = props => {
  const { locationOrigin } = useStore().state;

  const obj = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: props.breadcrumbs.map((b, idx) => ({
      "@type": "ListItem",
      position: idx + 1,
      name: b.label,
      item: `${locationOrigin.origin}${b.path}`,
    })),
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(obj) }} />;
};
